import "./NavBarMobile.css";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { FaChevronDown } from "react-icons/fa6";
import { FaChevronUp } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const NavBarMobile = () => {
    const {
        state: { selectedLink, openLink, mobileNavbar },
        dispatch,
    } = useContext(AppContext);

    const navigate = useNavigate();

    const isActive = (navlink) => {
        const path = window.location.pathname;
        return { color: path === navlink ? "#0B76F1" : "" };
    };

    const handleSelectLink = (type) => {
        if (type !== selectedLink) {
            dispatch({ type: "TOGGLE_LINK", payload: false });
            dispatch({ type: "SET_LINK", payload: type });
            dispatch({ type: "TOGGLE_LINK", payload: true });
        } else {
            dispatch({ type: "TOGGLE_LINK", payload: !openLink });
        }
    };

    const setDefault = () => {
        const isPathActive = window.location.pathname.split("/").includes("guide")
            ? "guide"
            : window.location.pathname.split("/").includes("components")
                ? "components"
                : "";
        handleSelectLink(isPathActive);
    };

    useEffect(() => {
        setDefault();
    }, []);

    return (
        <nav className={mobileNavbar ? "nav-menu active" : "nav-menu"}>
            <ul className="nav-menu-items">
                <div className="docs-nav active-nav noselect">
                    <IoMdClose
                        style={{
                            height: "2rem",
                            width: "2rem",
                            padding: "0.25rem",
                            marginLeft: "auto",
                            borderRadius: "8px",
                            backgroundColor: "#eeedeb",
                        }}
                        onClick={() =>
                            dispatch({ type: "TOGGLE_MOBILE_NAVBAR", payload: !mobileNavbar })
                        }
                    />
                    <>
                        <p onClick={() => handleSelectLink("guide")}>
                            <span>Guide</span>
                            {openLink && selectedLink === "guide" ? (
                                <FaChevronUp />
                            ) : (
                                <FaChevronDown />
                            )}
                        </p>
                        {openLink && selectedLink === "guide" ? (
                            <ul className="list">
                                <li onClick={() => navigate("/docs/guide/introduction")}>
                                    <div style={isActive("/docs/guide/introduction")}>
                                        Introduction
                                    </div>
                                </li>
                                <li onClick={() => navigate("/docs/guide/colors")}>
                                    <div style={isActive("/docs/guide/colors")}>Colors</div>
                                </li>
                                <li onClick={() => navigate("/docs/guide/typography")}>
                                    <div style={isActive("/docs/guide/typography")}>
                                        Typography
                                    </div>
                                </li>
                            </ul>
                        ) : null}
                    </>
                    <>
                        <p onClick={() => handleSelectLink("components")}>
                            <span>Components</span>
                            {openLink && selectedLink === "components" ? (
                                <FaChevronUp />
                            ) : (
                                <FaChevronDown />
                            )}
                        </p>
                        {openLink && selectedLink === "components" ? (
                            <ul className="list">
                                <li onClick={() => navigate("/docs/components/alert")}>
                                    <div style={isActive("/docs/components/alert")}>Alert</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/avatar")}>
                                    <div style={isActive("/docs/components/avatar")}>Avatar</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/badge")}>
                                    <div style={isActive("/docs/components/badge")}>Badge</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/button")}>
                                    <div style={isActive("/docs/components/button")}>Button</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/card")}>
                                    <div style={isActive("/docs/components/card")}>Card</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/headings")}>
                                    <div style={isActive("/docs/components/headings")}>
                                        Headings
                                    </div>
                                </li>
                                <li onClick={() => navigate("/docs/components/text")}>
                                    <div style={isActive("/docs/components/text")}>Text</div>
                                </li>
                                <li onClick={() => navigate("/docs/components/image")}>
                                    <div style={isActive("/docs/components/image")}>Image</div>
                                </li>
                            </ul>
                        ) : null}
                    </>
                    <div className="nav_right">
                        <div className="socials">
                            <a
                                className="navlink"
                                href="https://github.com/shahbazcse/PixelUI"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="36"
                                    height="36"
                                    viewBox="0 0 64 64"
                                >
                                    <path d="M32 6C17.641 6 6 17.641 6 32c0 12.277 8.512 22.56 19.955 25.286-.592-.141-1.179-.299-1.755-.479V50.85c0 0-.975.325-2.275.325-3.637 0-5.148-3.245-5.525-4.875-.229-.993-.827-1.934-1.469-2.509-.767-.684-1.126-.686-1.131-.92-.01-.491.658-.471.975-.471 1.625 0 2.857 1.729 3.429 2.623 1.417 2.207 2.938 2.577 3.721 2.577.975 0 1.817-.146 2.397-.426.268-1.888 1.108-3.57 2.478-4.774-6.097-1.219-10.4-4.716-10.4-10.4 0-2.928 1.175-5.619 3.133-7.792C19.333 23.641 19 22.494 19 20.625c0-1.235.086-2.751.65-4.225 0 0 3.708.026 7.205 3.338C28.469 19.268 30.196 19 32 19s3.531.268 5.145.738c3.497-3.312 7.205-3.338 7.205-3.338.567 1.474.65 2.99.65 4.225 0 2.015-.268 3.19-.432 3.697C46.466 26.475 47.6 29.124 47.6 32c0 5.684-4.303 9.181-10.4 10.4 1.628 1.43 2.6 3.513 2.6 5.85v8.557c-.576.181-1.162.338-1.755.479C49.488 54.56 58 44.277 58 32 58 17.641 46.359 6 32 6zM33.813 57.93C33.214 57.972 32.61 58 32 58 32.61 58 33.213 57.971 33.813 57.93zM37.786 57.346c-1.164.265-2.357.451-3.575.554C35.429 57.797 36.622 57.61 37.786 57.346zM32 58c-.61 0-1.214-.028-1.813-.07C30.787 57.971 31.39 58 32 58zM29.788 57.9c-1.217-.103-2.411-.289-3.574-.554C27.378 57.61 28.571 57.797 29.788 57.9z"></path>
                                </svg>
                            </a>
                            <a
                                className="navlink"
                                href="https://www.linkedin.com/in/shahbazcse/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <svg
                                    width="36"
                                    height="36"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                >
                                    <path
                                        fill="#0A66C2"
                                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 01-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 002 2.866v10.268a.88.88 0 00.885.866h10.226a.882.882 0 00.889-.866V2.865a.88.88 0 00-.889-.864z"
                                    />
                                </svg>
                            </a>
                            <a
                                className="navlink"
                                href="https://twitter.com/shahbaz_cse"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="36"
                                    height="36"
                                    viewBox="0 0 48 48"
                                >
                                    <path
                                        fill="#03A9F4"
                                        d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </ul>
        </nav>
    );
};

export default NavBarMobile;
